module.exports = __webpack_public_path__ + "fonts/PangMenZhengDao.e9b6e310.ttf";